<template>
  <div id="notifications">
    <div
      :class="[ 'notification', notification.type ]"
      v-for="(notification, index) in notifications"
      :key="index">
      <div class="close-notification">
        <i
          class="n-i n-i-close"
          @click="removeNotification(index)"/>
      </div>
      <div class="type-wrapper">
        <div class="type">
          {{ getTranslation(`notifications.type_${notification.type.toLowerCase()}`) }}
        </div>
      </div>
      <div class="message">{{ notification.message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      intervalId: null,
    };
  },
  computed: {
    notifications() {
      return this.$store.state.notifications;
    },
  },
  mounted() {
    this.intervalId = setInterval(() => {
      if (this.notifications && this.notifications.length) {
        this.$store.commit('REMOVE_FIRST_NOTIFICATION');
      }
    }, 5000);
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  methods: {
    removeNotification(index) {
      this.$store.commit('REMOVE_NOTIFICATION', index);
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/default/notifications';
</style>
